export async function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    try {
      const registration = await navigator.serviceWorker.register('/sw.js', {
        scope: '/'
      })

      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing
        if (newWorker) {
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // New content is available, refresh the pag
              window.location.reload()
            }
          })
        }
      })

      return registration
    } catch {
      //
    }
  }
}

export async function requestNotificationPermission() {
  if (!('Notification' in window)) {
    return false
  }

  const permission = await Notification.requestPermission()
  return permission === 'granted'
}

interface NotificationOptions {
  icon?: string
  badge?: string
  url?: string
}

export async function sendNotification(
  title: string,
  message: string,
  options: NotificationOptions = {}
) {
  if ('serviceWorker' in navigator && 'PushManager' in window) {
    try {
      const registration = await navigator.serviceWorker.ready

      await registration.showNotification(title, {
        body: message,
        icon: options.icon || '/logo.png',
        badge: options.badge || '/logo.png',
        tag: options.url,
        requireInteraction: true
      })
    } catch {
      //
    }
  }
}
